"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Split_1 = require("./model/Split");
var splitHorizontal = mobx_1.action(function (replace, left, right) {
    var split = new Split_1.HSplit();
    if (replace.parent) {
        replace.parent.replace(split, replace);
    }
    split.setLeft(left);
    split.setRight(right);
});
exports.splitHorizontal = splitHorizontal;
var splitVertical = mobx_1.action(function (replace, top, bottom) {
    var split = new Split_1.VSplit();
    if (replace.parent) {
        replace.parent.replace(split, replace);
    }
    split.setTop(top);
    split.setBottom(bottom);
});
exports.splitVertical = splitVertical;
